//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import sharedMethods from '../../sharedMethods';

export default {
  components: {  },
  props: ["group"],
  computed: {

  },
  data() {
    return {
      groupName: '',
	  groupOrientationOptions: [
        { label: "Landscape", value: "LANDSCAPE" },
        { label: "Portrait", value: "PORTRAIT" },
      ],
	  orientation: ''
    };
  },
  created() {
    this.groupName = this.group.GNAME;
	this.orientation = this.group.ORIENTATION;
  },
  methods: {
    ...mapActions([
      "updateGroupName",
	  "updateGroupSettings",
    ]),
	async updateSettings() {
		try {
			await this.updateGroupSettings({ groupId: this.group.GID, settings: { orientation: this.orientation }});
			sharedMethods.successNotify('Updated group settings.');
		} catch(err) {
			console.log(err);
			this.orientation = this.group.ORIENTATION;
			sharedMethods.errorNotify('Error updating group settings. Please try again later.')
		}
	}
  },
};
